import React, { useState } from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { AppBar, Toolbar, Typography, Button, Box, IconButton, Drawer, List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'

const navItems = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Blogs', to: '/blogs' },
  { label: 'Deals', to: '/deals' },
  { label: 'Contact', to: '/contact' },
]

export default function Header() {
  const [open, setOpen] = useState(false)
  const location = useLocation()
  const toggle = () => setOpen(!open)

  return (
    <AppBar position="sticky" color="primary" elevation={0}>
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
        <Box sx={{ display:'flex', alignItems:'center', gap: 1 }}>
          <Typography variant="h6" component={RouterLink} to="/" sx={{ fontWeight: 800, color: 'text.primary' }}>
            Bloomington Clean Services
          </Typography>
        </Box>

        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 1 }}>
          {navItems.map(item => (
            <Button key={item.to} component={RouterLink} to={item.to}
              variant={location.pathname === item.to ? 'contained' : 'text'} color="primary">
              {item.label}
            </Button>
          ))}
          <Button component={RouterLink} to="/estimate" variant="contained" color="primary">
            Get Free Estimate
          </Button>
        </Box>

        <IconButton onClick={toggle} sx={{ display: { xs: 'inline-flex', md: 'none' } }} aria-label="Open menu">
          <MenuIcon />
        </IconButton>
      </Toolbar>

      <Drawer anchor="right" open={open} onClose={toggle} PaperProps={{ sx: { width: 280 } }}>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 800 }}>Menu</Typography>
        </Box>
        <List>
          {navItems.map(item => (
            <ListItem key={item.to} disablePadding>
              <ListItemButton component={RouterLink} to={item.to} onClick={toggle}>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
          <Box sx={{ p:2 }}>
            <Button fullWidth component={RouterLink} to="/estimate" variant="contained" color="primary" onClick={toggle}>
              Get Free Estimate
            </Button>
          </Box>
        </List>
      </Drawer>
    </AppBar>
  )
}
